"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _appendCss = _interopRequireDefault(require("../utils/appendCss"));
var _Button_css = _interopRequireDefault(require("./Button_css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const iconSizeMap = {
  medium: "xs",
  large: "md",
  xlarge: "base",
  xxlarge: "lg"
};
class ButtonComp extends _react.Component {
  constructor(props) {
    super(props);
    (0, _appendCss.default)("arc_btn", _Button_css.default);
  }
  render() {
    const {
      innerRef,
      additionalProps,
      children,
      className,
      displayStyle,
      edgeStyle,
      icon,
      iconPosition,
      isDisabled,
      onClick,
      size,
      themeColor,
      type,
      value
    } = this.props;
    const isPresentationBtn = type === "presentation";
    const Component = isPresentationBtn ? "div" : "button";
    const buttonRef = isPresentationBtn ? null : innerRef;
    const wrapperClassList = (0, _classnames.default)({
      "button__elem": true,
      [className]: true,
      "is-linkLooking": displayStyle.indexOf("link") !== -1
    });
    const buttonClassList = (0, _classnames.default)({
      [displayStyle]: true,
      [edgeStyle]: true,
      [size]: true,
      [`${themeColor}-color`]: true,
      "icon-pos-left": !!icon && iconPosition === "left",
      "icon-pos-right": !!icon && iconPosition === "right",
      "is-linkLooking": displayStyle.indexOf("link") !== -1,
      "is-presentation-btn": isPresentationBtn
    });
    return /*#__PURE__*/_react.default.createElement("span", {
      className: wrapperClassList
    }, /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
      ref: buttonRef,
      type: isPresentationBtn ? null : type,
      className: buttonClassList,
      disabled: isDisabled,
      value: value,
      onClick: isPresentationBtn ? null : onClick
    }, additionalProps), !!icon && iconPosition === "left" && /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: icon,
      size: iconSizeMap[size]
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "button__label"
    }, children), !!icon && iconPosition === "right" && /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: icon,
      size: iconSizeMap[size]
    })));
  }
}
const Button = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    className = "",
    displayStyle = "primary",
    edgeStyle = "round",
    iconPosition = "left",
    isDisabled = false,
    size = "large",
    type = "button",
    themeColor = "primary",
    ...rest
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(ButtonComp, (0, _extends2.default)({
    innerRef: ref,
    className,
    displayStyle,
    edgeStyle,
    iconPosition,
    isDisabled,
    size,
    type,
    themeColor
  }, rest));
});
Button.propTypes = {
  /** Allows for additional key:value pairs to apply to the button HTML element. Examples are: ALT, TITLE, ID, etc. */
  "additionalProps": _propTypes.default.object,
  /** Additional classes for div wrapper */
  "className": _propTypes.default.string,
  /** Button display style [primary, primary-outlined, secondary, secondary-outlined, tertiary, tertiary-outlined, link, link-underlined] */
  "displayStyle": _propTypes.default.oneOf(["primary", "primary-outlined", "secondary", "secondary-outlined", "tertiary", "tertiary-outlined", "link", "link-underlined"]),
  /** Button edge style [round, square] */
  "edgeStyle": _propTypes.default.oneOf(["round", "square"]),
  /** Icon to display. Must be one of the material design icons */
  "icon": _propTypes.default.string,
  /** Icon position [left, right] */
  "iconPosition": _propTypes.default.oneOf(["left", "right"]),
  /** Determines if button is enabled or not */
  "isDisabled": _propTypes.default.bool,
  /** onClick event handler */
  "onClick": _propTypes.default.func,
  /** Button size [medium, large, xlarge, xxlarge] */
  "size": _propTypes.default.oneOf(["medium", "large", "xlarge", "xxlarge"]),
  /** Theme color variant [primary, accent, error, success] */
  "themeColor": _propTypes.default.oneOf(["primary", "accent", "error", "success"]),
  /** HTML Button Type attribute.  NOTE: use of the 'presentation' type, changes the markup from a button to a div.  This is meant to be used inside another larger linked section. [button, submit, presentation] */
  "type": _propTypes.default.oneOf(["button", "submit", "presentation"]),
  /** Form related value */
  "value": _propTypes.default.string,
  /** NOTE: prop name is "ref". a React REF object reference that is applied to the button element. Not applied in "presentation" mode. */
  "React REF (ref)": _propTypes.default.object
};
var _default = exports.default = Button;